module.exports = __webpack_public_path__ + "static/media/19ESCAP19.73f0a6c3.jpg";